/* eslint-disable @next/next/no-img-element, jsx-a11y/alt-text */
import type { ImageWithLoaderIndicatorProps } from './types';
import type { SyntheticEvent } from 'react';

import { useCallback, useState } from 'react';

import { Image } from './styles';

export const ImageWithLoaderIndicator = ({
  fadeInOnLoad = true,
  onLoad,
  shimmerDuration,
  className,
  ...rest
}: ImageWithLoaderIndicatorProps) => {
  const [isLoaded, setIsLoaded] = useState<boolean | undefined>(!fadeInOnLoad);

  const onLoadHandler = useCallback(
    (result: SyntheticEvent<HTMLImageElement>) => {
      if (fadeInOnLoad) {
        // sets the flag to undefined so the `data-loaded` attribute is removed from DOM
        setIsLoaded(undefined);
      }

      onLoad?.(result);
    },
    [fadeInOnLoad, onLoad]
  );

  return (
    <Image.ImageWrapper
      className={className}
      $shimmerDuration={shimmerDuration}
      data-loaded={isLoaded}
    >
      <img onLoad={onLoadHandler} {...rest} />
    </Image.ImageWrapper>
  );
};
